import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from 'src/app/app.constants';
import { AlertService } from 'src/app/core/alert.service';
import { AuthService } from 'src/app/core/auth.service';
import { DialogService } from 'src/app/core/dialog.service';
import { LoadingService } from 'src/app/core/loading.service';
import { RequestService } from 'src/app/core/request.service';
import { UtilityService } from 'src/app/core/utility.service';
import { BaseListComponent } from 'src/app/shared/base/base-list.component';
import { RouteAuthorities } from 'src/app/shared/base/base.models';
import { BaseService } from 'src/app/shared/base/base.service';
import { Company } from '../../companies/companies.models';
import { CompaniesService } from '../../companies/companies.service';
import { ConfigurationItem, SyncItem } from '../data-sync.models'

@Component({
  selector: 'app-data-sync-list',
  templateUrl: './data-sync-list.component.html',
  styleUrls: ['./data-sync-list.component.scss']
})
export class DataSyncListComponent extends BaseListComponent implements OnInit {

  public configurationItems: ConfigurationItem[];
  public company: Company;
  public isObjectsModalVisible: boolean = false;
  public syncItemModel: SyncItem = new SyncItem();

  constructor(    
    public authService: AuthService,
    public loadingService: LoadingService,
    public baseService: BaseService,
    public dialogService: DialogService,
    public alertService: AlertService,
    public utilityService: UtilityService,
    public requestService: RequestService,
    public translateService: TranslateService,
    public companiesService: CompaniesService) {
    super(authService, loadingService, baseService, dialogService, alertService, utilityService, requestService, translateService);
    this.authorities = new RouteAuthorities(authService, alertService, 'DATA_SYNC', 'DATA_SYNC', 'DATA_SYNC', 'DATA_SYNC');
    this.creatable = this.authorities.create;
    this.editable = this.authorities.update;
    this.deletable = this.authorities.delete;
    this.activatable = this.authorities.update;
  }

  ngOnInit(): void {
    this.url = `${Constants.contextPath}/data-sync/configurations`;
    this.getGridData();    
    
    this.companiesService.getCompany(this.authService.companyId).then(response => {      
      this.company = response;
    });
  }

  getRowNumber(item:any, array: any[]) {
    return array?.indexOf(item);    
  }

  viewObjects(item: SyncItem){
    this.isObjectsModalVisible = true;

    this.syncItemModel = item;
  }
}
